import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { goToCheckout, PRICE, PRICE_ANCHOR } from "../src/config";
export function StickyCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <AnimatePresence data-id="element-199" data-mp="1v6i8uy4au5pu">
      {show && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: "spring",
      stiffness: 260,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-[#0d0b22]/95 backdrop-blur" data-id="element-200" data-mp="1v9nzwiwhnho7">
          <div className="mx-auto flex max-w-4xl items-center justify-between gap-3 px-4 py-3 sm:px-6" data-id="element-201" data-mp="295rljntaqhp2">
            <div className="min-w-0" data-id="element-202" data-mp="3fbrfdkq03pp2">
              <p className="truncate text-sm font-semibold text-white" data-id="element-203" data-mp="3fct3oqw128oq">
                The Bilingual Sales Machine
              </p>
              <p className="text-xs text-slate-400" data-id="element-204" data-mp="3aehqc66ixg1r">
                <span className="line-through" data-id="element-205" data-mp="3p1uhcaf3odzj">{PRICE_ANCHOR}</span>{" "}
                <span className="font-bold text-emerald-400" data-id="element-206" data-mp="3kaumrbtge807">{PRICE}</span> · Oferta por tiempo limitado
              </p>
            </div>
            <button onClick={goToCheckout} className="flex shrink-0 items-center gap-2 rounded-xl bg-emerald-500 px-4 py-3 text-sm font-extrabold uppercase text-emerald-950 transition-colors hover:bg-emerald-400" data-id="element-207" data-mp="1vtuge81d9y5">
              Quiero acceso
              <ArrowRightIcon className="h-4 w-4" data-id="element-208" data-mp="6voima0fflfi" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}